/**
 * Catalogo de icones disponiveis para Agentes.
 *
 * Mesma logica de ``team-icons.ts``: backend grava ``agents.icon`` como
 * string livre; frontend mapeia para componentes do lucide. Catalogo
 * curado para nao depender do user digitar um nome qualquer.
 */

import {
  Beaker,
  Bot,
  Brain,
  ClipboardList,
  Code2,
  Compass,
  Cpu,
  FileSearch,
  Gauge,
  GraduationCap,
  Layers,
  Lightbulb,
  LucideIcon,
  MessageSquare,
  PenTool,
  Scale,
  Settings2,
  ShieldCheck,
  Sparkles,
  Stethoscope,
  Wand2,
  Wrench,
  Zap,
} from "lucide-react";

export interface AgentIconDef {
  name: string;
  Icon: LucideIcon;
  label: string;
}

export const AGENT_ICONS: AgentIconDef[] = [
  { name: "bot", Icon: Bot, label: "Agente generico" },
  { name: "sparkles", Icon: Sparkles, label: "Assistente" },
  { name: "brain", Icon: Brain, label: "Raciocinio" },
  { name: "wand", Icon: Wand2, label: "Magia" },
  { name: "message", Icon: MessageSquare, label: "Conversa" },
  { name: "lightbulb", Icon: Lightbulb, label: "Ideias" },
  { name: "compass", Icon: Compass, label: "Triagem" },
  { name: "scale", Icon: Scale, label: "Juridico" },
  { name: "shield", Icon: ShieldCheck, label: "Compliance" },
  { name: "clipboard", Icon: ClipboardList, label: "Procedimentos" },
  { name: "file-search", Icon: FileSearch, label: "Pesquisa" },
  { name: "beaker", Icon: Beaker, label: "Pesquisa cientifica" },
  { name: "code", Icon: Code2, label: "Engenharia" },
  { name: "cpu", Icon: Cpu, label: "Tecnico" },
  { name: "wrench", Icon: Wrench, label: "Operacoes" },
  { name: "settings", Icon: Settings2, label: "Configuracao" },
  { name: "layers", Icon: Layers, label: "Plataforma" },
  { name: "gauge", Icon: Gauge, label: "Performance" },
  { name: "zap", Icon: Zap, label: "Rapido" },
  { name: "pen", Icon: PenTool, label: "Conteudo" },
  { name: "graduation", Icon: GraduationCap, label: "Treinamento" },
  { name: "stethoscope", Icon: Stethoscope, label: "Saude" },
];

const ICON_BY_NAME = new Map(AGENT_ICONS.map((d) => [d.name, d]));

export function getAgentIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Bot;
  return ICON_BY_NAME.get(name)?.Icon ?? Bot;
}

export function getAgentIconDef(
  name: string | null | undefined,
): AgentIconDef | null {
  if (!name) return null;
  return ICON_BY_NAME.get(name) ?? null;
}
